import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import { templateGroupDetail } from '@/views/template/templateGroupManage/request';
export default {
  props: ['insuranceId', 'customerInsuranceId', 'templateControlsGroupId'],
  data() {
    return {
      src: '',
      list: [],
      pageIndex: 0,
      templateCongfig: [],
      disableColor: false,
      homePage: ''
    };
  },
  watch: {
    templateControlsGroupId: {
      handler() {
        this.list = [];
        this.pageIndex = 0;
        this.getInfoFun();
      },
      deep: true
    }
  },
  created() {
    console.log();
    this.$nextTick(() => {
      this.getInfoFun();
    });
  },
  methods: {
    async getInfoFun() {
      const {
        templateCongfig
      } = await templateGroupDetail({
        templateGroupId: this.templateControlsGroupId
      });
      this.templateCongfig = JSON.parse(templateCongfig);
      console.log(this.templateCongfig, 3333);
      this.templateCongfig.map(item => {
        if (item.isHomePage) {
          this.list.push(item);
          this.homePage = item.controlsGroupPageType;
          console.log(this.list, '-------------list--------');
        }
      });
      this.src = process.env.VUE_APP_Pdf + '/#/preview/' + this.insuranceId + '/' + this.customerInsuranceId + '/' + this.templateControlsGroupId + '/' + this.list[this.pageIndex].controlsGroupPageType;
      console.log(this.src, 'src');
    },
    previousFun() {
      if (this.pageIndex == 0) {
        return false;
      }
      this.src = '';
      this.pageIndex--;
      this.$nextTick(() => {
        this.src = process.env.VUE_APP_Pdf + '/#/preview/' + this.insuranceId + '/' + this.customerInsuranceId + '/' + this.templateControlsGroupId + '/' + this.list[this.pageIndex].controlsGroupPageType;
      });
    },
    nextFun() {
      console.log(this.list, this.pageIndex, '--------list nextFun---------');
      if (this.homePage === 'QUERY_INFO_PAGE') {
        // 查询记录页平铺展示
        if (this.pageIndex == this.templateCongfig.length - 1) {
          this.disableColor = true;
          return false;
        } else {
          this.pageIndex++;
          this.disableColor = false;
          this.list.push(this.templateCongfig[this.pageIndex]);
          this.src = '';
          console.log(this.insuranceId, this.customerInsuranceId, this.templateControlsGroupId, this.list[this.pageIndex].controlsGroupPageType, '--------list nextFun---------');
          this.$nextTick(() => {
            this.src = process.env.VUE_APP_Pdf + '/#/preview/' + this.insuranceId + '/' + this.customerInsuranceId + '/' + this.templateControlsGroupId + '/' + this.list[this.pageIndex].controlsGroupPageType;
          });
        }
      } else {
        var _obj$controlsGroupCon, _res$buttonPopUpConfi;
        const obj = this.list[this.pageIndex];
        // const type =
        //   obj?.controlsGroupConfig?.controlsConfig[obj?.controlsGroupConfig?.controlsConfig.length - 1].controlsObject
        //     ?.buttonInfo[0].controlsJump;
        // console.log(obj, 'nextFun-----------');
        let res = obj === null || obj === void 0 || (_obj$controlsGroupCon = obj.controlsGroupConfig) === null || _obj$controlsGroupCon === void 0 || (_obj$controlsGroupCon = _obj$controlsGroupCon.controlsConfig) === null || _obj$controlsGroupCon === void 0 || (_obj$controlsGroupCon = _obj$controlsGroupCon[obj.controlsGroupConfig.controlsConfig.length - 1]) === null || _obj$controlsGroupCon === void 0 || (_obj$controlsGroupCon = _obj$controlsGroupCon.controlsObject) === null || _obj$controlsGroupCon === void 0 ? void 0 : _obj$controlsGroupCon.buttonInfo[0];
        const type = res.controlsJump || (res.buttonPopUp ? (_res$buttonPopUpConfi = res.buttonPopUpConfig.buttonInfo.find(i => i.buttonEvent == 'jump')) === null || _res$buttonPopUpConfi === void 0 ? void 0 : _res$buttonPopUpConfi.controlsJump : '');
        if (type == 'TO_PAY') {
          return false;
        }
        const arr = this.list.filter(item => item.controlsGroupPageType == type);
        if (arr.length == 0) {
          this.templateCongfig.map(item => {
            if (item.controlsGroupPageType == type) {
              this.list.push(item);
            }
          });
        }
        this.src = '';
        this.pageIndex++;
        this.$nextTick(() => {
          this.src = process.env.VUE_APP_Pdf + '/#/preview/' + this.insuranceId + '/' + this.customerInsuranceId + '/' + this.templateControlsGroupId + '/' + this.list[this.pageIndex].controlsGroupPageType;
        });
      }
      console.log(this.src, 222);
    }
  }
};